/**
 * Variáveis de marca editáveis no painel.
 *
 * O padrão fica em src/styles/itv/base.css. O que for gravado em
 * theme_tokens sobrescreve o padrão, em todas as páginas do site.
 */
export type TokenMarca = {
  key: string;
  rotulo: string;
  grupo: string;
  padrao: string;
  tipo: "cor" | "texto";
};

export const TOKENS_MARCA: readonly TokenMarca[] = [
  { key: "--ouro", rotulo: "Dourado principal", grupo: "Marca", padrao: "#e4aa6b", tipo: "cor" },
  { key: "--ouro-escuro", rotulo: "Dourado escuro", grupo: "Marca", padrao: "#b97f3e", tipo: "cor" },
  { key: "--ouro-texto", rotulo: "Dourado de texto", grupo: "Marca", padrao: "#8a5f2c", tipo: "cor" },
  { key: "--ouro-grad-1", rotulo: "Botão, início do degradê", grupo: "Marca", padrao: "#e9b678", tipo: "cor" },
  { key: "--ouro-grad-2", rotulo: "Botão, fim do degradê", grupo: "Marca", padrao: "#d99a4e", tipo: "cor" },

  { key: "--tinta", rotulo: "Texto principal", grupo: "Texto", padrao: "#363639", tipo: "cor" },
  { key: "--cinza", rotulo: "Texto secundário", grupo: "Texto", padrao: "#55555a", tipo: "cor" },
  { key: "--cinza-claro", rotulo: "Texto de apoio", grupo: "Texto", padrao: "#8b8b8f", tipo: "cor" },

  { key: "--branco", rotulo: "Fundo branco", grupo: "Superfícies", padrao: "#ffffff", tipo: "cor" },
  { key: "--areia", rotulo: "Fundo areia", grupo: "Superfícies", padrao: "#f7f4ef", tipo: "cor" },
  { key: "--linha", rotulo: "Linhas e bordas", grupo: "Superfícies", padrao: "#e5e1da", tipo: "cor" },

  {
    key: "--serif",
    rotulo: "Fonte dos títulos",
    grupo: "Tipografia",
    padrao: "'Newsreader', Georgia, 'Times New Roman', serif",
    tipo: "texto",
  },
  {
    key: "--sans",
    rotulo: "Fonte do texto",
    grupo: "Tipografia",
    padrao: "'Jost', 'Avenir Next', 'Segoe UI', system-ui, sans-serif",
    tipo: "texto",
  },
  {
    key: "--largura-max",
    rotulo: "Largura máxima do conteúdo",
    grupo: "Medidas",
    padrao: "1440px",
    tipo: "texto",
  },
  { key: "--raio", rotulo: "Arredondamento", grupo: "Medidas", padrao: "6px", tipo: "texto" },
] as const;

const PERMITIDOS = new Set(TOKENS_MARCA.map((t) => t.key));

/** Vira um bloco :root com o que foi gravado no painel. */
export function cssDosTokens(tokens: Record<string, string>): string {
  const linhas = Object.entries(tokens)
    .filter(([key]) => PERMITIDOS.has(key))
    // Nada de ponto e vírgula ou chave vindos do banco entrando no CSS.
    .filter(([, value]) => !/[;{}<]/.test(value))
    .map(([key, value]) => `${key}:${value};`);
  return linhas.length === 0 ? "" : `:root{${linhas.join("")}}`;
}
